import {
  STORAGE_KEYS,
  DEFAULT_THRESHOLDS,
  DEFAULT_NOTIFICATION_TIMINGS,
  DEFAULT_NOTIFICATION_LEVELS,
} from '../config';

/**
 * Save sensor configuration to localStorage
 * @param {Object} config - The configuration object to save
 * @returns {boolean} - Success status
 */
export const saveConfig = (config) => {
  try {
    localStorage.setItem(STORAGE_KEYS.SENSOR_CONFIG, JSON.stringify(config));
    console.log('💾 Configuration saved:', config);
    return true;
  } catch (error) {
    console.error('❌ Error saving config:', error);
    return false;
  }
};

/**
 * Load sensor configuration from localStorage
 * @returns {Object|null} - The saved configuration or null
 */
export const loadConfig = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.SENSOR_CONFIG);
    if (saved) {
      const config = JSON.parse(saved);
      console.log('📂 Configuration loaded:', config);
      return config;
    }
  } catch (error) {
    console.error('❌ Error loading config:', error);
  }
  return null;
};

/**
 * Get initial sensor config (from storage or defaults)
 * @returns {Object} - The sensor configuration
 */
export const getInitialConfig = () => {
  const saved = loadConfig();
  return saved || { ...DEFAULT_THRESHOLDS, refreshInterval: 1 };
};

export const saveNotificationConfig = (config) => {
  try {
    localStorage.setItem(STORAGE_KEYS.NOTIFICATION_CONFIG, JSON.stringify(config));
    return true;
  } catch (error) {
    console.error('Error saving notification config:', error);
    return false;
  }
};

export const loadNotificationConfig = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.NOTIFICATION_CONFIG);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error('Error loading notification config:', error);
  }
  return null;
};

export const getInitialNotificationConfig = () => {
  const saved = loadNotificationConfig();
  return saved
    ? {
        notificationTimings: { ...DEFAULT_NOTIFICATION_TIMINGS, ...(saved.notificationTimings || saved) },
        notificationLevels: { ...DEFAULT_NOTIFICATION_LEVELS, ...(saved.notificationLevels || {}) },
      }
    : {
        notificationTimings: { ...DEFAULT_NOTIFICATION_TIMINGS },
        notificationLevels: { ...DEFAULT_NOTIFICATION_LEVELS },
      };
};

/**
 * Save theme preference to localStorage
 * @param {boolean} isDark - Whether dark theme is enabled
 */
export const saveTheme = (isDark) => {
  try {
    localStorage.setItem(STORAGE_KEYS.THEME, JSON.stringify(isDark));
  } catch (error) {
    console.error('❌ Error saving theme:', error);
  }
};

/**
 * Load theme preference from localStorage
 * @returns {boolean} - Whether dark theme is enabled (defaults to false)
 */
export const loadTheme = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEYS.THEME);
    if (saved !== null) {
      return JSON.parse(saved);
    }
  } catch (error) {
    console.error('❌ Error loading theme:', error);
  }
  return false; // Default light theme
};
